// NOTE: most of this code is inspired or from [typesafe-actions](https://github.com/piotrwitek/typesafe-actions)
// We couldn't use it directly because of it's use of Object.assign, which isn't
// supported on IE11 (and which we probably can't reliably polyfill).

/**
 * @module
 *
 * WARNING * WARNING * WARNING
 *
 * NOTICE: this dispatch pattern is being deprecated and should NOT BE COPIED.
 *
 * tracking: https://gitlab.sas.com/dvr/html/react-commons/issues/250
 *
 * If you have a use case, please leave a comment on the issue.
 */

/**
 * Creates a standard action that is compatible with FSA.
 * @see https://github.com/redux-utilities/flux-standard-action
 *
 * @param type The action type (should probably be a literal type)
 */
export function action<T extends string, P = undefined, M = undefined>(
  type: T,
  payload?: P,
  meta?: M
): StandardAction<T, P, M> {
  return { type, payload, meta } as any;
}

// NOTE: this Action type could be shorter with intersections, but the intersections don't
//     | seem to distribute at the moment (typescript 3.2.2)
// prettier-ignore
/**
 * A standard action that is compatible with FSA.
 * @see https://github.com/redux-utilities/flux-standard-action
 */
export type StandardAction<T extends string, P, M> =
  P extends void
  ? M extends void ? { type: T } : { type: T; meta: M }
  : M extends void ? { type: T; payload: P } : { type: T; payload: P; meta: M };

/**
 * A bottom type for all actions. Should be the same type that redux uses.
 *
 * TODO: do we want to include redux types in another module for this purpose?
 */
export type AnyAction = {
  type: any;
  [field: string]: any;
};

// prettier-ignore
/**
 * Infers Action union-type from an object of action creators (and nested
 * objects of action creators).
 *
 * @example
 * const actionCreators = {
 *   a: () => action('type1'),
 *   b: () => action('type2', { data: 5 }),
 *   c: () => action('type2', { data: 6 }),
 * };
 * // { type: 'type1' } | { type: 'type2', payload: { data: number } }
 * type MyActions = ActionType<typeof actionCreators>;
 *
 * @example
 * // the module should export action creators and/or nested action creator objects
 * import * as actionCreators from './my-action-creators';
 * type MyActions = ActionType<typeof actionCreators>;
 */
export type ActionType<A> =
  // base case
  A extends (...args: any[]) => { type: string } ? ReturnType<A>
  // recurse on objects, retrieving ActionType of each field
  : {
    1: DeepActionType<A[keyof A]>;
    0: never;
  }[A extends object ? 1 : 0];

type DeepActionType<T> = T extends any ? ActionType<T> : never;
